const TRUNCATE_PHONE_CHARACTERS_TO_SHOW = 4;
const PUBLIC_PHONE_MIN_LENGTH = 8;

/**
 * @deprecated Use the `truncatePhoneNumber` function from the `@pflegia/util/functions/truncate-phone` module instead.
 */
export const truncatePhoneNumber = (phoneNumber: string) => {
  if (phoneNumber.length <= PUBLIC_PHONE_MIN_LENGTH) {
    return phoneNumber;
  }
  const firstFourDigits = phoneNumber.slice(0, TRUNCATE_PHONE_CHARACTERS_TO_SHOW);
  const lastFourDigits = phoneNumber.slice(-TRUNCATE_PHONE_CHARACTERS_TO_SHOW);
  return `${firstFourDigits}...${lastFourDigits}`;
};
